import React from 'react'

import cn from 'classnames'

import c from './LoaderRound.module.scss'

export const LoaderRound = ({ className = '' }) => {
  return <div className={`${cn(c[className], c.preloader)}`} />
}
